'use client';

import s from 'Workadabra/app/[lang]/home/sections/hero/styles.module.css';
import { rdBecomeProvider, rdFindService, rdHeroEarn, rdHeroPost, rdHeroPre, rdHeroServed, rdHeroSub } from 'Workadabra/translations';
import { StoreBadges } from '@bomdisoft/components';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

const APP_URL = process.env.NEXT_PUBLIC_APP_URL ?? '#';

const ArrowIcon = () => (
  <svg aria-hidden='true' fill='none' height={18} viewBox='0 0 24 24' width={18} xmlns='http://www.w3.org/2000/svg'>
    <path d='M5 12h14M13 6l6 6-6 6' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} />
  </svg>
);

export const HeroSection = () => {
  const params = useParams();
  const language = getLanguageFromLocale(params?.lang as string);

  return (
    <section className={s.root} data-testid='hero-section' id='hero'>
      <div className={s.content}>
        <div>
          <h1 className={s.headline} data-testid='hero-headline'>
            {rdHeroPre[language]} <span className={s.highlight}>{rdHeroServed[language]}</span>
            {`, `}
            <span className={s.highlight}>{rdHeroEarn[language]}</span> {rdHeroPost[language]}
          </h1>

          <p className={s.sub}>{rdHeroSub[language]}</p>

          <div className={s.ctaRow}>
            <a className={s.primaryCta} data-testid='hero-primary-cta' href={APP_URL}>
              {rdFindService[language]}
              <ArrowIcon />
            </a>
            <a className={s.secondaryCta} data-testid='hero-secondary-link' href='#earn'>
              {rdBecomeProvider[language]}
              <ArrowIcon />
            </a>
          </div>

          <StoreBadges className={s.storeBadges} language={language} product='workadabra' testId='hero-badge' />
        </div>
      </div>
    </section>
  );
};
